import { WidgetEventStruct } from "../../widget-event.struct";
import { PermissionWidgetEnum } from "../../../enums";

export class PermissionWidgetEventStruct extends WidgetEventStruct {
  public event_permission_widget_type: PermissionWidgetEnum;
} 
